<div class="container mx-auto px-4 pb-0 text-black safe-area-container">
  <treatment-locator-search-filters (treatmentTypeChanged)="radioChange($event)" (applyFilters)="onApplyFilters($event)"
    (clearFilters)="onClearFilters()">
  </treatment-locator-search-filters>

  <mat-spinner *ngIf="isLoading"></mat-spinner>

  <div *ngIf="!isLoading" class="mt-1">
    <div *ngIf="hasSearch" class="">

      @if (treatmentType == TreatmentType.HealthServies || treatmentType == TreatmentType.SupportGroups) {
      <div class="text-center"
        *ngIf="(servicesProviderList$ | async) == null || (servicesProviderList$ | async)?.length == 0">
        <p class="p-20 text-xl bg-white rounded">{{ 'No Results' | translate }}</p>
      </div>
      }
      @else {
      <div class="text-center"
        *ngIf="(treatmentProviderList$ | async) == null || (treatmentProviderList$ | async)?.length == 0">
        <p class="p-20 text-xl bg-white rounded">{{ 'No Results' | translate }}</p>
      </div>
      }
    </div>
    <div class="bg-white shadow overflow-hidden sm:rounded-md">
      <ul role="list" class="divide-y divide-gray-200">
        @if (treatmentType == TreatmentType.HealthServies || treatmentType == TreatmentType.SupportGroups) {
        <app-support-and-health-services-list-item *ngFor="let item of servicesProviderList$ | async" [provider]="item"
          (showProviderEvent)="openSupportProviderDialog($event)"></app-support-and-health-services-list-item>
        }
        @else {
        <app-treatment-provider-list-item *ngFor="let item of treatmentProviderList$ | async" [treatmentProvider]="item"
          (showProviderEvent)="openProviderDialog($event)"></app-treatment-provider-list-item>
        }
      </ul>

    </div>
  </div>
</div>
